import { mapState, mapGetters } from "vuex";
var fits = require("./lib-fits-front");
const moment = require("moment");
// import qs from "qs";

export default {
    computed: {
        ...mapState(["sConfig", "sMenus", "sOrdertmp", "sOrderH", "sOrderI", 'sCrtType', 'sBKMenu', 'sTblid', 'sPassCode']),
        ...mapState(['sTblid', 'sPassCode']),
        ...mapState(['sOrderH', 'sOrderI']),
        ...mapState(['sRst', 'sOrdertmp']),
        ...mapState(['sPhone', 'sPotype']),
        ...mapState(['sPoH', 'sPoI']),
        ...mapState(['sStopSale']),
        ...mapState(['sTimeTip']),
        ...mapGetters(['sGetConfig']),
        ...mapState(['sCustCount']),
        // ...mapGetters(['sGetConfig', 'setCrtType', 'setBKMenu'])
    },
    methods: {
        async gInit() {
            try {
                this.gShowLoading();



                //取得設定
                var res = await this.apiGetConfig();
                let config = res.data;
                this.$store.commit("setConfig", config);
                console.log("config", JSON.stringify(config));


                //取得菜單
                res = await this.apiGetMenus();
                this.bkmenu = res.data;
                this.$store.commit("setBKMenu", this.bkmenu); //太常用了，存在store
                var menutype = this.bkmenu.menutype;
                if (menutype.length > 0) {
                    this.gSetCrtType(menutype[0]);
                }

                res = await this.apiGetStopSale();
                console.log("停售", res);
                this.$store.commit("setStopSale", res.data);
                // console.log("apiGetStopSale", res.data);

                //網址參數
                var tblid = this.gStr(this.$route.query.tblid);
                this.$store.commit("setTblid", tblid);
                var passcode = this.gStr(this.$route.query.PassCode);
                this.$store.commit("setPassCode", passcode);

                //檢查passcode

                var query = { tblid: tblid, passcode: passcode };

                // if (tblid != "" && passcode != "" && passcode != "mpo" && passcode != "sure") { //passcode=="mpo" = super user
                if (tblid != "" && passcode != "" && passcode != "mpo") { //passcode=="mpo" = super user
                    let res = await this.apiCheckPassCode(query);
                    let checked = res.data[0];
                    console.log("checked", checked);
                    if (!checked) {
                        alert("QRCODE已失效,請重新掃碼");
                        window.location.href = "about:blank";
                        return;
                    }
                }

                //方案1:取得ocheck
                let ocheck = null
                query = { tblid: tblid, passcode: passcode };
                if (this.sPassCode != "" && this.sTblid != "") {
                    res = await this.apiGetOCheck(query);
                    ocheck = res.data;
                    if (ocheck.orderi == undefined) ocheck.orderi = [];
                    this.$store.commit("setOCheck", ocheck);
                }

                //方案2:不輸電話號碼仍要，取得ocheck
                if (this.sGetConfig("noPhoneIuput") && this.sTblid) {
                    res = await this.apiGetOCheck(query);
                    ocheck = res.data;
                    if (ocheck.orderi == undefined) ocheck.orderi = [];
                    this.$store.commit("setOCheck", ocheck);
                }


                //取得訂單
                var phone = this.gStr(sessionStorage.getItem("phone"));
                query = { phone: phone };
                console.log("取得訂單", query);
                if (phone != "") {
                    res = await this.apiGetEaterPo(query);
                    this.$store.commit("setEaterPo", res.data);
                    console.log(res.data);
                }



                //取得ordertmp
                res = await this.apiGetOrdertmp();
                let ordertmp = res.data

                // console.log("ordertmp", ordertmp)
                this.$store.commit("setOrderTmp", ordertmp);
                // console.log(res.data.objs);
                // console.log(this.sRst);
                this.gClearLoading();

                //取得吃到飽菜單
                let buffetMenuType = this.getBuffetMenuType(this.bkmenu.menutype, ocheck, config)

                console.log("buffetMenuType", buffetMenuType)
                console.log("ocheck", ocheck)
                this.bkmenu.menutype = buffetMenuType
                this.$store.commit("setBKMenu", this.bkmenu); //太常用了，存在store

                let lastSendTime = this.getLastSendTime(ocheck, config)
                console.log("+min >>", lastSendTime)
                this.$store.commit("setLastSendTime", lastSendTime);

                console.log("now >>", fits.now())


                let timeTip = this.calcTimeTip();
                console.log("tt", timeTip);
                this.$store.commit("setTimeTip", timeTip);
                setInterval(() => {
                    // console.log("calcTimeTip >>", timeTip)
                }, 1000);




                // if (this.sPassCode != "" && this.sTblid != "") { //點單模式

                //     //有交易過，先顯示帳單
                //     var sum = this.gSum(this.sOrderI, "Amt");
                //     if (sum > 0) {
                //         return this.$refs.rOCheck.show(this.sOrderH, this.sOrderI);
                //     }

                //     //沒有交易，顯示歡迎頁
                //     return this.$refs.rWelcome.show();
                // } else { //訂單模式

                //     // return this.$refs.rEnter.show();
                //     return this.$refs.rWelcome.show();

                // }


            } catch (error) {
                console.log("gInit()", error);
                this.gClearLoading();
            }
        },
        gCheckLvData(lv) { //檢查指定階層可選數量
            var sum = this.gSum(lv.options, "Qty");
            // if (lv.limit == 0) {
            //     return true;
            // }

            // if (sum > lv.limit) {
            //     return false;
            // }

            // if (lv.lock) {
            //     if (sum != lv.limit) {
            //         return false;
            //     }
            // }
            if (lv.max == 0) return true;

            if (sum < lv.min || sum > lv.max) return false;

            if (lv.min == lv.max)
                if (sum != lv.max) return false;

            return true;
        },
        gCheckS1Data(s1) { //檢查指定群組可選數量(含蓋該群的所有階層)
            if (s1.Groups == undefined) {
                return true;
            }
            for (let i = 0; i < s1.Groups.length; i++) {
                var lv = s1.Groups[i];
                if (!this.gCheckLvData(lv)) {
                    return false;
                }
            }
            return true;
        },
        gGetDcText(item) { //取得折扣文字說明
            var dc = item.Discount;
            if (Array.isArray(dc)) {
                if (dc.length > 0) {
                    var obj = dc[0];
                    if (obj == null) {
                        return "";
                    }
                    // console.log(dc[0], Object.hasOwn(dc[0], 'text'))
                    if (Object.hasOwn(dc[0], "text")) {
                        // return dc[0].text;
                        console.log(dc[0].text);
                        return dc[0].text;
                    }
                }
            }
            return "";
        },
        gCalcDcAmt(qty, amt, discount) { //帶入主品項數量/套餐集合總價/折扣obj，計算折扣金額(負數)  //加入購物車前計算單項餐點金額使用
            console.log("gCalcDcAmt", qty, amt, discount, Array.isArray(discount));
            // if (discount == undefined || discount == null) {
            //     return 0;
            // }

            if (!Array.isArray(discount)) {
                return 0;
            }

            if (discount.length == 0) {
                return 0;
            }

            var dc = discount[0];
            var validQty = parseInt(qty / dc.buyQty);
            var rate = dc.rate / 100;
            var doAmt = Math.round(amt * rate) - amt;
            doAmt *= validQty;
            console.log("gCalcDcAmt", validQty, amt, rate, doAmt);
            return doAmt;
        },

        gBtnRound() {
            var type = this.sGetConfig("btnRadius");
            if (type == "圓角") {
                return true;
            }
            return false;
        },
        gImgRound() {
            var type = this.sGetConfig("imgRadius");
            if (type == "圓角") {
                return "0.5rem";
            }
            if (type == "正圓") {
                return "15rem";
            }
            return 0;
        },
        gFindItem(obj) {
            var mi = this.sBKMenu.menuitem.find(
                (r) => (r.TypeNo == obj.TypeNo) & (r.ItemName == obj.ItemName)
            );
            if (!mi) {
                return null;
            }

            var find = this.sBKMenu.extitem.find((r) => r.itemname == obj.ItemName);
            if (find) {
                mi.ImgFile = find.imgfile;
                mi.Remark = find.desc;
                mi.DispName = find.dispname;
                mi.Discount = find.discount;
            }
            if (mi.DispName == "" || mi.DispName == undefined) {
                mi.DispName = obj.ItemName;
            }
            return mi;
        },
        gGetTypeOptions(menutype) {
            var list = [];
            menutype.options.forEach((mt) => {
                // console.log(mt);
                var row = this.gFindItem(mt);
                if (row) {
                    list.push(row);
                }
            });
            return list;
        },
        gSetCrtType(menutype) {
            var list = [];
            menutype.options.forEach((mt) => {
                var row = this.gFindItem(mt);
                if (row) {
                    list.push(row);
                }
            });
            menutype.options = list;

            this.$store.commit("setCrtType", menutype);
        },
        getBuffetMenuType(pMenuType, pOCheck, pConfig) {
            if (!pConfig.chkBuffet) return pMenuType
            if (!pConfig.buffetS1) return pMenuType
            if (pConfig.buffetS1.length == 0) return pMenuType
            let orderi = pOCheck.orderi;
            console.log("orderi", orderi)
            if (!orderi) return []
            if (orderi.length == 0) return []
            let sumOrderi = fits.groupBy(orderi, "ItemName", "Qty")
            console.log("sumOrderi", sumOrderi)
            let buffetS1 = pConfig.buffetS1;
            console.log("buffetS1", JSON.stringify(buffetS1))
            let data = []
            for (let i = 0; i < sumOrderi.length; i++) {
                const el = sumOrderi[i];
                console.log("尋找人頭項目", i, el);
                let find = buffetS1.find(r => r.itemname == el.ItemName && el.Qty > 0)
                console.log("find", i, find);

                if (find) {
                    let typelist = find.typelist;
                    data = pMenuType.filter((r) => {
                        return typelist.find(l => l == r.id)
                    })
                    break
                    // console.log("data", data)
                }
            }

            // console.log(pConfig)
            // console.log(pMenuType)
            // console.log("orderi", orderi)
            return data
        },

        getLastSendTime(pOCheck, pConfig) {
            try {
                // if (!pConfig.chkBuffet.value) return ""
                let orderi = pOCheck.orderi;
                if (!orderi) return ""
                if (orderi.length == 0) return ""

                let MaxOrderTime = fits.val(pConfig.MaxOrderTime.value)
                if (MaxOrderTime == 0) return ""
                console.log("第一個品項", orderi[0].FileDate)
                let time = fits.dateAdd(orderi[0].FileDate, MaxOrderTime)
                return time
            } catch (error) {
                return ""
            }
        },

        gOverSendTime() {
            try {
                let time = this.$store.state.sLastSendTime
                // console.log(time, "對上", fits.now(), time < fits.now())
                // return true
                if (time != "") {
                    if (time < fits.now()) return true
                }
                return false
            } catch (error) {
                return false
            }
        },
        calcTimeTip() {
            console.log("calcTimeTip");
            let timeB = "";
            if (this.$store.state.sOrderH) timeB = fits.unTZ(this.$store.state.sOrderH.FileDate);

            // let timeB = fits.unTZ(this.$store.state.sOrderH.FileDate);
            let minute = this.$store.state.sConfig.MaxOrderTime.value;
            let timeE = fits.dateAdd(timeB, minute);
            let span = this.$store.state.sConfig.cSendTime.value;
            let maxQty = this.$store.state.sConfig.maxQty.value;
            let maxItemQty = this.$store.state.sConfig.maxItemQty.value;
            let mm = fits.val(this.sGetConfig("BNS_MaxDiningTime"));
            let maxDiningTime = fits.dateAdd(timeB, mm);
            let nextSendTime = this.getNextSendTime();
            let orderi = this.sOrderI.filter((r) => r.POSID == "eat");
            let lastSendTime = "";

            if (orderi.length > 0) {
                lastSendTime = orderi[orderi.length - 1].FileDate; // 最後傳送時間
                lastSendTime = moment(lastSendTime).format("YYYY-MM-DD HH:mm:ss");
            }
            // let comedown = 0;
            // comedown = this.getNextSendTime() - span; // 下次可傳送時間為幾分鐘後
            // if (comedown > 0) comedown = 0;
            return {
                timeB: timeB,
                minute: minute,
                timeE: timeE,
                span: span,
                maxItemQty: maxItemQty,
                maxQty: maxQty,
                maxDiningTime: maxDiningTime,
                // comedown: comedown,
                lastSendTime: lastSendTime,
                nextSendTime: nextSendTime,
            };
        },

        getNextSendTime() {
            if (!this.sOrderI) return "";
            let orderi = this.sOrderI.filter((r) => r.POSID == "eat");
            if (orderi == 0) return "";

            let lastSendTime = orderi[orderi.length - 1].FileDate; // 最後傳送時間
            // let now = fits.now();
            let time = fits.dateAdd(lastSendTime, this.sGetConfig("cSendTime")); // 下次可傳送時間
            // if (now > time) return true;
            // let diff = fits.dateDiff(lastSendTime, "m");
            // return diff;
            return time;
        }

    }
}